import { useLayoutEffect, useRef } from "react";

/**
 * The frame's top bar height, published as --signet-topbar-height on the
 * shell, for a module page with a sticky bar of its own to stick beneath it.
 *
 * Measured rather than written down, because the bar is 59px on a desktop
 * and wraps to two rows on a phone, where the nav moves under the brand.
 * The Creators pages use it: the hub they copy had its own sticky top bar,
 * and at top: 0 it slid underneath Signet's.
 */
export function useTopbarHeight<Shell extends HTMLElement, Bar extends HTMLElement>() {
  const shell = useRef<Shell>(null);
  const bar = useRef<Bar>(null);
  useLayoutEffect(() => {
    const header = bar.current;
    const root = shell.current;
    if (!header || !root) return;
    const publish = () => root.style.setProperty("--signet-topbar-height", `${header.getBoundingClientRect().height}px`);
    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(header);
    return () => observer.disconnect();
  }, []);
  return { shell, bar };
}
